import "../login_page/LoginPage.css";

import { useEffect, useState, type FormEvent } from "react";

import { Alert, Button, Group, PasswordInput, Stack, Title } from "@mantine/core";
import { authMethods } from "@utils/AuthUtil";
import { getUserFromLocalStorage } from "@utils/CommonUtil";
import { isValidPassword } from "@utils/passwordUtils";
import { logOut } from "@actions/userActions";
import { selectUserForcePassChange } from "@utils/redux-utils/selectors/userSelectors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [countDown, setCountDown] = useState(3);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const forcePasswordChange = useSelector(selectUserForcePassChange);

  function handleCancel() {
    if (forcePasswordChange) {
      dispatch(logOut("/login"));
    } else {
      navigate(-1);
    }
  }

  useEffect(() => {
    if (!success) return;
    if (countDown === 0) {
      dispatch(logOut());
      return;
    }

    const timerId = setTimeout(() => {
      setCountDown(countDown - 1);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [countDown, success]);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");
    try {
      const response = await authMethods.changePassword(oldPassword, newPassword);
      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (err: any) {
      const message = err?.response?.data?.message || t("Login.changePasswordError");
      setError(message);
    }
  }

  function validateForm() {
    return (
      newPasswordRepeat.length > 0 &&
      isValidPassword(newPassword) &&
      oldPassword.length > 0 &&
      newPassword === newPasswordRepeat
    );
  }

  return (
    <div className="Login">
      {success ? (
        <Alert color="green" variant="light" className="alert">
          {t("Login.passwordChanged") + " " + countDown}
        </Alert>
      ) : (
        <form onSubmit={handleSubmit}>
          {error && (
            <Alert color="red" variant="light" mb="sm">
              {error}
            </Alert>
          )}
          <Title order={3}>{t("Login.changePasswordTitle")}</Title>
          <Stack gap="sm">
            <PasswordInput
              id="oldPassword"
              label={t("Login.oldPassword")}
              autoFocus
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value.trim())}
            />
            <PasswordInput
              id="newPassword"
              label={t("Login.newPassword")}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value.trim())}
              error={
                newPassword.length > 0 && !isValidPassword(newPassword)
                  ? t("Login.passwordRuleWarning")
                  : undefined
              }
            />
            <PasswordInput
              id="newPasswordRepeat"
              label={t("Login.newPasswordRepeat")}
              value={newPasswordRepeat}
              onChange={(e) => setNewPasswordRepeat(e.target.value.trim())}
            />
            <Group justify="flex-start" mt="sm">
              <Button.Group>
                {!!getUserFromLocalStorage() && (
                  <Button color="red" onClick={handleCancel} type="button">
                    {t("Login.cancel")}
                  </Button>
                )}
                <Button disabled={!validateForm()} type="submit">
                  {t("Login.changePassword")}
                </Button>
              </Button.Group>
            </Group>
          </Stack>
        </form>
      )}
    </div>
  );
}
